/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import NavItemButton from '../NavItemButton';
import Tooltip from '../../../../../../../Tooltip';
import { hideOnClassName } from '../NavItem/helper';

import s from './navItemTooltip.module.css';


class NavItemTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.alignTooltip = this.alignTooltip.bind(this);
  }

  alignTooltip() {
    return this.props.alignTooltipRight
      ? {
        points: ['tr', 'br'],
        overflow: { adjustX: 0, adjustY: 0 },
        targetOffset: ['0px', '-10px'],
        useCssRight: true,
      }
      : undefined;
  }

  render() {
    const { customClass, destroyTooltipOnHide } = this.props;
    return (
      <Tooltip
        content={this.props.content}
        event="hover"
        align={this.alignTooltip()}
        placement={this.props.alignTooltipRight ? 'bottomRight' : 'bottom'}
        customClassName={s.hideTooltip}
        destroyTooltipOnHide={destroyTooltipOnHide}
      >
        <div className={`${customClass} ${hideOnClassName(this.props.hideOn, this.props.data.customClassNav)}`} data-qa={this.props.qaTagName}>
          <NavItemButton notifs={this.props.notifs} data={this.props.data} displayLink={this.props.displayLink} />
        </div>
      </Tooltip>
    );
  }
}

NavItemTooltip.propTypes = {
  content: PropTypes.oneOfType(
    [PropTypes.element, PropTypes.object, PropTypes.string, PropTypes.func],
  ).isRequired,
  hideOn: PropTypes.string,
  notifs: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  data: PropTypes.shape({
    customClassNav: PropTypes.string,
    ...NavItemButton.propTypes.data,
  }).isRequired,
  alignTooltipRight: PropTypes.bool,
  qaTagName: PropTypes.string,
  displayLink: PropTypes.bool,
  customClass: PropTypes.string,
  destroyTooltipOnHide: PropTypes.bool,

};

NavItemTooltip.defaultProps = {
  hideOn: '',
  notifs: null,
  alignTooltipRight: false,
  qaTagName: '',
  displayLink: undefined,
  customClass: '',
  destroyTooltipOnHide: false,
};

export default NavItemTooltip;
